<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Política Comercial",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Política Comercial",
    };
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="card-title mb-3">MATRIZ</h4> -->

            <ul>
              <li>Pedido sujeito a análise de crédito</li>
              <li>Pedido mínimo de R$ 600,00</li>
              <li>Frete Grátis para o Estado de São Paulo.</li>
              <li>Regiões Centro-Oeste, Sul e Sudeste (exceto São Paulo) Frete Grátis para pedidos acima de R$ 1.501,00</li>
              <li>Regiões Norte e Nordeste: Pedidos até R$ 2.500,00 frete por conta do cliente. Para pedidos acima de R$ 2.501,00 frete compartilhado em 50% cliente e 50% Calypso</li>
              <li>Pedidos serão analisados pelo departamento financeiro para liberação de prazo de pagamento</li>
              <li class="font-weight-bold">3 Primeiras compras somente à vista</li>
            </ul>

            <!-- <h6 class="mt-4">REGRAS PARA ENTREGA VIA MOTOBOY</h6>
            <h6 class="mt-3">Saída São Paulo/SP para cidades abaixo:</h6>
            
            <li>Arujá</li>
            <li>Barueri</li>
            <li>Caieiras</li>
            <li>Carapicuíba</li>
            <li>Cotia</li>
            <li>Diadema</li>
            <li>Embu Das Artes</li>
            <li>Guarulhos</li>
            <li>Itapevi</li>
            <li>Itaquaquecetuba</li>
            <li>Jandira </li>
            <li>Mairiporã</li>
            <li>Mauá</li>
            <li>Osasco</li>
            <li>Santana De Parnaíba</li>
            <li>Santo André</li>
            <li>São Bernardo</li>
            <li>São Caetano Do Sul</li>
            <li>Taboão Da Serra</li>

            <h6 class="mt-3">Valor a ser pago pelo cliente no 1º boleto:</h6>

            <li>Cidades listadas acima: R$ 30,00</li>
            <li>Cidade de São Paulo: R$ 20,00</li>
            <li>Não fazemos entregas em cidades que não constem na lista acima</li>-->
          </div> 
        </div>

        <!-- <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">FILIAL ITAJAÍ</h4>

            <li>Pedido sujeito a análise de crédito</li>
            <li>Pedidos de até R$ 2.500,00 - Frete por conta do cliente</li>
            <li>Pedidos acima de R$ 2.501,00 - Frete CIF (todo estado de SP), exceto região Norte e Nordeste</li>
            <li >Caso tenha incidência de frete/impostos, serão cobrados no primeiro boleto</li>
            <li>Pedidos serão analisados pelo departamento financeiro para liberação de prazo de pagamento</li>
             <li>3 Primeiras compras somente à vista</li>
          </div>
        </div> -->
      </div>
    </div>
  </Layout>
</template>

<style lang="scss">
  ul {
    padding-left: 20px;
  }

  li::marker {
    // list-style-position: outside;
    margin-right: 13px;
  }
</style>